import React, { useEffect, useRef, useState, } from 'react';
import HtmlParser from 'react-html-parser';
import { Link, useHistory, } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import $ from 'jquery';
import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';
import { GlobalFormats } from '../../classes/main/globalFormats';

import { responseGet, globalSettings, styles, validateEmail, languageObjGet, isUndNullEmp, sendMessageCloseCurrentWindowAsync, awaitDelay, } from '../../helpers/settings';
import Menu from '../main/Menu';

const currentMethod = 'ForgotPassword';

export default function ForgotPassword({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const history = useHistory();
    const defaultValueFormDataSet = () => {
        return {
            email: '',
        };
    }
    const [emailError, setEmailError] = useState('');
    const [formData, setFormData] = useState(defaultValueFormDataSet());
    const recaptchaRef = useRef(ReCAPTCHA);
    const urlStop = '#nothing';
    const controls = {
        buttons: {
            home: {
                //className: 'btn btn-sm btn-outline-success',
                className: 'btn btn-outline-success',
                id: 'btnHome',
            },
            login: {
                //className: 'btn btn-sm btn-outline-primary mx-1',
                //className: 'btn btn-sm btn-outline-primary mx-1',
                className: 'btn btn-outline-primary mx-1',
                id: 'btnLogin',
            },
            send: {
                //className: 'btn btn-sm btn-outline-primary mx-1',
                className: 'btn btn-outline-primary mx-1',
                id: 'btnSend',
            },
        },
        icons: {
            home: {
                id: 'iconHome',
                className: globalSettings?.icons?.home,
            },
            login: {
                id: 'iconLogin',
                className: globalSettings?.icons?.powerOff,
            },
            send: {
                id: 'iconSend',
                className: globalSettings?.icons?.checkCircle,
            },
        },
        inputs: {
            email: {
                id: 'inputEmail',
            },
        },
        spinners: {
            home: {
                id: 'spHome',
                className: '',
            },
            login: {
                id: 'spLogin',
                className: '',
            },
            send: {
                id: 'spSend',
                className: '',
            }
        },
        urls: {
            home: {
                id: 'urlhome',
                className: '',
            },
            forgotYourPassword: {
                id: 'urlForgotYourPassword',
                className: 'btn-link',
            },
            reCaptchaPrivaciConditions: {
                id: 'urlReCaptchaPrivaciConditions',
                className: '',
            },
            userRegister: {
                id: 'urlRequestAccount',
                className: '',
            },
            registerStatus: {
                id: 'urlStatusRegister',
                className: '',
            },
        },
    };
    //#endregion variables

    //#region methods
    const checkFormDataAsync = async () => {
        const currentMethod = 'checkFormDataAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: formData?.email, subMethod: currentMethod, })?.result) {
                setEmailError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (!validateEmail({ email: formData?.email })) {
                setEmailError(globalSettings?.messages?.youMustEnterValidEmail?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`;
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const recoverPasswordPostAsync = async ({ e = {} }) => {
        let response = responseGet();
        try {
            e?.preventDefault();
            setEmailError('');

            //#region check data
            response = await checkFormDataAsync();
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion check data

            //sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true);
            await controlsStatusSetAsync({ processType: 1, subMethod: currentMethod, });

            //#region get recaptcha
            const recaptchaToken = await recaptchaRef.current.executeAsync();
            recaptchaRef?.current?.reset();
            //#endregion get recaptcha

            //#region Forgot password
            const dataObj = {
                email: formData.email,
                recaptchaToken: recaptchaToken,
                languageId: languageObj?.id,
            };

            const result = await axios?.post(
                `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlAccounts}${globalSettings?.app?.backend?.urlForgotPassword}`,
                dataObj,
            );

            response = result.data;
            if (!response?.isSuccess || response?.isWarning) {
                await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setFormData(defaultValueFormDataSet());
            //#endregion Forgot password

            //sendMessage(response.msgType, replaceMessages(0, response.msgText).result, 0, true, false, null);
            await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });

            //#region Message final
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            //#endregion Message final
        } catch (ex) {
            await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}</br>`;
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataGetAsync = async () => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            if (auth?.isLoged()) {
                history.push('/');
            }
        } catch (ex) {
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const buttonsProcessAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'buttonsProcessAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e?.preventDefault, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            switch (e?.currentTarget?.id) {
                case controls?.buttons?.home?.id:
                    await controlsStatusSetAsync({ processType: 2, subMethod: currentMethod, });
                    //await new Promise((resolve) => setTimeout(resolve, 1000));
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                    window.location.href = globalSettings?.app?.backend?.urlHome;
                    break;
                case controls?.buttons?.login?.id:
                    await controlsStatusSetAsync({ processType: 3, subMethod: currentMethod, });
                    //await new Promise((resolve) => setTimeout(resolve, 1000));
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                    window.location.href = globalSettings?.app?.backend?.urlLogin;
                    break;
                default:
                    await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const controlsStatusSetAsync = async ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.send?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.send?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.send?.id}`)?.removeClass();

                    $(`#${controls?.icons?.home?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.home?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.home?.id}`)?.removeClass();

                    $(`#${controls?.icons?.login?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.login?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.login?.id}`)?.removeClass();

                    $(`#${controls?.icons?.send?.id}`)?.addClass(controls?.icons?.send?.className);
                    $(`#${controls?.buttons?.send?.id}`)?.addClass(controls?.buttons?.send?.className);
                    $(`#${controls?.spinners?.send?.id}`)?.addClass(controls?.spinners?.send?.className);

                    $(`#${controls?.icons?.home?.id}`)?.addClass(controls?.icons?.home?.className);
                    $(`#${controls?.buttons?.home?.id}`)?.addClass(controls?.buttons?.home?.className);
                    $(`#${controls?.spinners?.home?.id}`)?.addClass(controls?.spinners?.home?.className);

                    $(`#${controls?.icons?.login?.id}`)?.addClass(controls?.icons?.login?.className);
                    $(`#${controls?.buttons?.login?.id}`)?.addClass(controls?.buttons?.login?.className);
                    $(`#${controls?.spinners?.login?.id}`)?.addClass(controls?.spinners?.login?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.send?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.send.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.home?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.home.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.login?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));

            $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
                'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
                'target': (processType !== 0 ? '' : '_blank'),
            });

            if (processType !== 0) {
                $(`#${controls?.buttons?.send?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.home?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            console.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName='home' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.forgotYourPassword?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    {/*<li className='breadcrumb-item'><a href='#'>Home</a></li>*/}
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.forgotYourPassword?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div>
                            <ul>
                                <li>
                                    {HtmlParser(globalSettings?.messages?.forgotPasswordSubTitle01?.[languageObj?.id])}.
                                </li>
                                <li>
                                    {HtmlParser(globalSettings?.messages?.forgotPasswordSubTitle02?.[languageObj?.id])}.
                                </li>
                            </ul>
                        </div>
                        <hr />

                        <div className='login-box' style={styles?.loginBox}>

                            <div className='card card-primary card-outline shadow-lg'>

                                {/*Header*/}
                                <div className='card-header'>
                                    <h5><img src={globalSettings?.images?.passwordIcon} alt='forgotYourPassword' style={styles?.cardHeaderLogo} /> - {globalSettings?.labels?.forgotYourPassword?.[languageObj?.id]}</h5>
                                </div>

                                <form onSubmit={(e) => recoverPasswordPostAsync({ e: e })} method='post'>

                                    {/*Body*/}
                                    <div className='card-body'>
                                        <p className='login-box-msg'>{globalSettings?.labels?.enterYourEmail?.[languageObj?.id]}</p>

                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.email?.id}
                                                    className='form-control'
                                                    placeholder={globalSettings?.labels?.email?.[languageObj?.id]}
                                                    //autoFocus
                                                    onChange={(e) => setFormData({ ...formData, 'email': e?.target?.value })}
                                                    onFocus={() => setEmailError('')}
                                                    value={!isUndNullEmp({ data: formData?.email, subMethod: currentMethod, })?.result ? formData?.email : ''}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.email?.[languageObj?.id]}
                                                />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={globalSettings?.icons?.envelope} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(emailError)}</div>
                                        </div>

                                        <div>
                                            <i className={globalSettings?.icons?.userCheck} />
                                            {/* {' '}<Link to={globalSettings?.app?.backend?.urlUserRegister} className='btn-link'>{globalSettings?.labels?.registerNewMembership}</Link> */}
                                            {' '}<a id={controls?.urls?.userRegister?.id} href={globalSettings?.app?.backend?.urlUserRegister} className='btn-link'>{globalSettings?.labels?.registerNewMembership?.[languageObj?.id]}</a>
                                        </div>
                                        <div>
                                            <i className={globalSettings?.icons?.userClock} />
                                            {/* {' '}<Link to={globalSettings?.app?.backend?.urlRegisterStatus} className='btn-link'>{globalSettings?.labels?.checkRegistrationStatus}</Link> */}
                                            {' '}<a id={controls?.urls?.registerStatus?.id} href={globalSettings?.app?.backend?.urlRegisterStatus} className='btn-link'>{globalSettings?.labels?.checkRegistrationStatus?.[languageObj?.id]}</a>
                                        </div>
                                    </div>
                                    {/*Footer*/}
                                    <div className='card-footer'>
                                        <div className='form-group text-right'>
                                            <button id={controls?.buttons?.send?.id}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.send?.[languageObj?.id]}
                                                data-toggle='tooltip'
                                                type='submit'
                                                className={controls?.buttons?.send?.className}>
                                                <i id={controls?.icons?.send?.id} className={controls?.icons?.send?.className} /> <span id={controls?.spinners?.send?.id} className='' aria-hidden='true'></span>
                                            </button>
                                            <button id={controls?.buttons?.home?.id}
                                                //to={globalSettings?.app?.backend?.urlHome}
                                                title={globalSettings?.labels?.home?.[languageObj?.id]}
                                                data-toggle='tooltip'
                                                type='button'
                                                className={controls?.buttons?.home?.className}
                                                onClick={(e) => buttonsProcessAsync({ e: e, subMethod: e?.currentTarget?.id, })}>
                                                <i id={controls?.icons?.home?.id} className={controls?.icons?.home?.className} /> <span id={controls?.spinners?.home?.id} className='' aria-hidden='true'></span>
                                            </button>
                                            <button id={controls?.buttons?.login?.id}
                                                // href={globalSettings?.app?.backend?.urlLogin}
                                                title={globalSettings?.labels?.login?.[languageObj?.id]}
                                                data-toggle='tooltip'
                                                type='button'
                                                className={controls?.buttons?.login?.className}
                                                onClick={(e) => buttonsProcessAsync({ e: e, subMethod: e?.currentTarget?.id, })}>
                                                <i id={controls?.icons?.login?.id} className={controls?.icons?.login?.className} /> <span id={controls?.spinners?.login?.id} className='' aria-hidden='true'></span>
                                            </button>
                                        </div>
                                    </div>

                                </form>

                                <div hidden>
                                    <ReCAPTCHA className='g-recaptcha'
                                        ref={recaptchaRef}
                                        sitekey={globalSettings?.app?.reCAPTCHA?.reCAPTCHASiteKey}
                                        size='invisible' />
                                </div>

                            </div>

                            <div className='text-muted text-center text-small'>
                                <p>
                                    <small>{globalSettings?.labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a id={controls?.urls?.reCaptchaPrivaciConditions?.id} target='_blank' href={globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions} rel='noreferrer'>{globalSettings?.labels?.privacyAndConditions?.[languageObj?.id]}</a></small>
                                </p>
                            </div>
                        </div>

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
        </div>
    )
}